import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { activeButton, activeId } from '../../actions'

import './Filter.css';

const toUpperCase = word => word.toUpperCase();

class List extends Component {

  state = {
    activeButtonList: null,
  }

  render() {
    const { item, activeButton, nameButton } = this.props;
    if (!item) return null;
    const sortItem = item.sort(function(a, b) {
      const nameA = a.title.toUpperCase();
      const nameB = b.title.toUpperCase();
      if (nameA < nameB) { return -1 }
      if (nameA > nameB) { return 1 }
      return 0;
    });
    return (
      <ul className="filter-list">
        {sortItem.map(({ name, title }) => {
          const buttonClass = nameButton === name ? 'filter-list__button filter__buttons-active' : 'filter-list__button';
          return (
            <li key={name} className="filter-list__item">
              <button onClick={() => {
                this.setState({
                  activeButtonList: name
                });
                return activeButton(name)
              } } className={buttonClass}>{toUpperCase(title)}</button>
            </li>
          );
        })}
      </ul>
    );
  }
}

class Filter extends Component {

  state = {
    activeButtons: null,
  };

  activeButtons = (name) => {
    this.setState({ activeButtons: name })
    this.props.dispatch(activeButton(name))
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeButtons !== this.state.activeButtons) {
      this.props.dispatch(activeId('0'))
    }
  }

  render() {
    const { activeButtons } = this.state;
    const { filter } = this.props;
    if (!filter) return null;

    if (this.state.activeButtons === null) {
      this.setState({ activeButtons: Object.keys(this.props.filter)[0] })
      this.props.dispatch(activeButton(Object.keys(this.props.filter)[0]))
    }


    const filterButton = Object.values(filter);

    return (
      <nav className="filters">
        {filterButton.map(({ title, item, name }) => {
          const buttonClass = activeButtons === name ? 'filter__buttons filter__buttons-active' : 'filter__buttons';
          return (
            <div key={name} className="filter__item">
              <button
                onClick={() => {
                  this.setState({
                    [name]: !this.state[name]
                  });
                  return this.activeButtons(name)

                }}
                className={buttonClass}
              >
                {toUpperCase(title)}
              </button>
              <ReactCSSTransitionGroup
                transitionName="example"
                transitionAppear={true}
                transitionAppearTimeout={500}
                transitionEnterTimeout={500}
                transitionLeaveTimeout={300}>
                { item && this.state[name] ?
                  <List item={item}
                        activeButton={this.activeButtons}
                        nameButton={this.state.activeButtons}
                  /> :
                  null
                }
              </ReactCSSTransitionGroup>
            </div>
          );
        })}
      </nav>
    );
  }
}

export default Filter
